import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class recomendationsService {
    showRecomendations: Subject<void> = new Subject<void>();
    constructor() { }
}